import { ModalType } from '../../../../../models/common/modal/modal-config';

/**
 * This constant used for all form navigation
 */
export const FORM_CONSTANTS = {
  PERSONAL_DETAIL: 'personalDetailForm',
  ADDRESS: 'addressForm',
  CONTACT: 'contactForm',
  PAY_RATE: 'payRatesForm',
  JOB_INFORMATION: 'jobInformationForm',
  BANK_DETAIL: 'bankDetailForm',
  ASSIGN_LOCATION: 'assignLocationForm',
  ASSIGN_TIMESHEET: 'assignTimesheetForm',
  TRAINING_LICENSE: 'traininglicense',
  UNAVAIBILITY: 'unavaibilityForm',
  LEAVE: 'leaveForm',
  TASK:'task',
  FORM:'form',
  REWARD:"reward",
  ONBOARDING:"onboarding",
  TIMESHEET: 'TIMESHEET',
};

export const UNSAVED_CHANGES_MODAL_CONSTANTS = {
  type: ModalType.WARNING,
  title: 'Alert',
  message: 'There are Unsaved changes in the ',
  buttons: {
    button1: {
      text: 'Discard Change',
    },
    button2: {
      text: 'Cancel',
    },
  },
};
